import React, { useEffect } from "react";
import "./style.scss";
import { Link } from "react-router-dom";
// import ShowIcon from "../../../../assets/icons/arrow-down-blue.svg";

// import { capitalizeFirstLetter, convertToMillions } from "../../../../utils/helpers/string";

import { useDispatch } from "react-redux";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import right_tick from "../../assets/icons/yes_tick.svg";
import Card from "./Card";
import { setSelectedChallenge } from "../../utils/store/reducers/accountMetricsSlice";
import "react-loading-skeleton/dist/skeleton.css";
import { FormatUSD } from "../../utils/helpers/string";

function Tier({ tiers, activeTier, setActiveTier, setFooterValue }) {
  const challenges = tiers?.challenges;

  const sortedNumbers = [...challenges];
  const tiersNew = sortedNumbers?.sort(
    (a, b) => b?.starting_balance - a?.starting_balance
  );

  console.log("sortedNumbers", sortedNumbers.reverse());

  const dispatch = useDispatch();

  const handleActive = (id) => {
    setActiveTier(id);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tiers]);

  return (
    <>
      {tiers?.challenges?.length > 3 ? (
        <Splide
          aria-label="My Favorite Images"
          options={{
            // type: "Loop",
            autoplay: true,
            pagination: false,
            perPage: 3,
            perMove: 1,
            width: "100%",
            drag: "free",
            gap: "10px",
            pauseOnHover: false,
            breakpoints: {
              1550: { perPage: 3, gap: "1rem" },
              1350: { perPage: 2, gap: "1rem" },
              970: { perPage: 1, gap: "1rem" },
            },
          }}
        >
          {tiers?.challenges?.map((newTiers, index) => {
            return (
              <SplideSlide key={index}>
                <div className="tier_wrapper">
                  <div className="tier_upper">
                    <div className="tier-type">
                      <span>{`$${newTiers?.price}/month`}</span>
                    </div>
                    <div
                      className="tier-price"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <h3>
                        ${(newTiers?.starting_balance / 1000).toFixed(1)}k
                      </h3>
                      <span>Challenge</span>
                    </div>

                    <Link
                      to={`/Assessments-checkout/${newTiers?.id}`}
                      className="get_started_link"
                    >
                      <button
                        className="get_started_btn"
                        onClick={() =>
                          dispatch(setSelectedChallenge(newTiers?.id))
                        }
                      >
                        Get Started
                      </button>
                    </Link>
                  </div>
                  <Card
                    className={`tier-container ${
                      tiers?.id === activeTier ? "tier-highlight" : ""
                    }`}
                    onClick={() => handleActive(tiers.id)}
                  >
                    <div className="tier-num">
                      <div className="tier_val">
                        <p className="heading">Starting Balance</p>
                        <p>${newTiers?.starting_balance ?? "-"} </p>
                      </div>
                      <div className="tier_val">
                        <p className="heading">Profit Share</p>
                        <p>up to {newTiers?.profit_share ?? "-"} %</p>
                      </div>
                      <div className="tier_val">
                        <p className="heading">Profit Target</p>
                        <p>$ {newTiers?.profit_target_1 ?? "-"}</p>
                      </div>
                      <div className="tier_val">
                        <p className="heading">Max Position</p>
                        <p>
                          {index === 0
                            ? 5
                            : index === 1
                            ? 10
                            : index === 2
                            ? 15
                            : index === 3
                            ? 20
                            : 25}
                          Contracts
                        </p>
                      </div>
                      <div className="tier_val">
                        <p className="heading">Max Loss</p>
                        <p>
                          $
                          {newTiers?.starting_balance *
                            (newTiers?.max_loss / 100) ?? "-"}
                        </p>
                      </div>

                      <div className="tier_val">
                        <p className="heading">Payout</p>
                        <p>
                          {tiers?.name?.toLowerCase() === "advanced plan"
                            ? "Weekly"
                            : "Biweekly"}
                        </p>
                      </div>
                      <div className="tier_val">
                        <p className="heading">Min Trading Days</p>
                        <p>{newTiers?.min_trading_days ?? "0"} days</p>
                      </div>

                      <div className="tier_val">
                        <p className="heading">Micro Scaling</p>
                        <p> {true ? <img src={right_tick} /> : "No"}</p>
                      </div>
                      <div className="tier_val">
                        <p className="heading">Consistency Rule</p>
                        <p>{true ? <img src={right_tick} /> : "No"}</p>
                      </div>
                    </div>
                  </Card>
                </div>
              </SplideSlide>
            );
          })}
        </Splide>
      ) : (
        tiersNew?.map((newTiers, index) => {
          return (
            <div className="tier_wrapper">
              <div className="tier_upper">
                <div className="tier-type">
                  <span>{`$${newTiers?.price}/month`}</span>
                </div>
                <div
                  className="tier-price"
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <h3>${(newTiers?.starting_balance / 1000).toFixed(1)}k</h3>
                  <span>Challenge</span>
                </div>

                <Link
                  to={`/Assessments-checkout/${newTiers?.id}`}
                  className="get_started_link"
                >
                  <button
                    className="get_started_btn"
                    onClick={() => dispatch(setSelectedChallenge(newTiers?.id))}
                  >
                    Get Started
                  </button>
                </Link>
              </div>
              <Card
                className={`tier-container ${
                  tiers?.id === activeTier ? "tier-highlight" : ""
                } `}
                onClick={() => handleActive(tiers.id)}
              >
                <div className="tier-num">
                  <div className="tier_val">
                    <p className="heading">Starting Balance</p>
                    <p>{FormatUSD(newTiers?.starting_balance) ?? "-"}</p>
                  </div>
                  <div className="tier_val">
                    <p className="heading">Profit Share</p>
                    <p>
                      {tiers?.name?.toLowerCase() === "advanced plan" ||
                      tiers?.name?.toLowerCase() === "zero plan"
                        ? ""
                        : "up to "}
                      {newTiers?.profit_share ?? "-"} %
                    </p>
                  </div>
                  <div className="tier_val">
                    <p className="heading">Profit Target</p>
                    <p>{FormatUSD(newTiers?.profit_target_1) ?? "-"}</p>
                  </div>
                  <div className="tier_val">
                    <p className="heading">Max Position</p>
                    <p>
                      {tiers?.name?.toLowerCase() === "zero plan"
                        ? index === 0
                          ? 1
                          : index === 1
                          ? 3
                          : 6
                        : index === 0
                        ? 5
                        : index === 1
                        ? 10
                        : index === 2
                        ? 15
                        : index === 3
                        ? 20
                        : 25}
                      &nbsp;Contracts
                    </p>
                  </div>
                  <div className="tier_val">
                    <p className="heading">Max Loss</p>
                    <p>
                      {FormatUSD(
                        newTiers?.starting_balance * (newTiers?.max_loss / 100)
                      ) ?? "-"}
                    </p>
                  </div>
                  {/* Insert Max Daily Loss after Max Loss for Zero Plan */}
                  {tiers?.name?.toLowerCase() === "zero plan" && (
                    <div className="tier_val">
                      <p className="heading">Max Daily Loss</p>
                      <p>
                        {FormatUSD(
                          newTiers?.starting_balance *
                            (newTiers?.max_daily_loss / 100)
                        ) ?? "-"}
                      </p>
                    </div>
                  )}

                  <div className="tier_val">
                    <p className="heading">Payout</p>
                    <p>
                      {tiers?.name?.toLowerCase() === "advanced plan" ||
                      tiers?.name?.toLowerCase() === "zero plan"
                        ? "Weekly"
                        : "Biweekly"}
                    </p>
                  </div>
                  <div className="tier_val">
                    <p className="heading">Min Trading Days</p>
                    <p>
                      {newTiers?.min_trading_days ?? "0"}{" "}
                      {tiers?.name?.toLowerCase() === "zero plan"
                        ? "day"
                        : "days"}
                    </p>
                  </div>

                  <div className="tier_val">
                    <p className="heading">Micro Scaling</p>
                    <p> {true ? <img src={right_tick} /> : "No"}</p>
                  </div>
                  <div className="tier_val">
                    <p className="heading">Consistency Rule</p>
                    <p>
                      {tiers?.name?.toLowerCase() === "advanced plan" ? (
                        "Evaluation Only"
                      ) : tiers?.name?.toLowerCase() === "zero plan" ? (
                        "Qualified Only"
                      ) : (
                        <img src={right_tick} />
                      )}
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          );
        })
      )}
    </>
  );
}

export default Tier;
